import { useMemo, useEffect } from "react";
import { Dispatch, connect } from "react-redux";
import { IStore } from "reducers";
import { fetchManifest } from "actions/product-media-actions";
import { get360Source } from "components/product-media/components/use-360-source";

interface IProps {
    manifest: string;
    src: string;
    children: any; // (list: string[], loading: boolean): any;
}

interface IReduxProps {
    ids: string[];
    isFetching: boolean;
}

// prettier-ignore
interface IDispatchProps {
    onFetch (manifest: string): void;
}

const ManifestLoader = ({
    manifest,
    ids,
    src,
    children,
    isFetching,
    onFetch,
}: IProps & IReduxProps & IDispatchProps) => {
    const list = useMemo(() => get360Source({ url: src, image_ids: ids }), [src, ids]);
    useEffect(() => onFetch(manifest), [onFetch, manifest]);
    return children(list, isFetching);
};

const mapStateToProps = (store: IStore): IReduxProps => ({
    ids: store.mediaManifest.payload && store.mediaManifest.payload.image_ids,
    isFetching: store.mediaManifest.isFetching || !store.mediaManifest.payload,
});

const mapDispatchToProps = (dispatch: Dispatch<{}>): IDispatchProps => ({
    onFetch: (manifest: string) => dispatch(fetchManifest(manifest)),
});

export default connect<IReduxProps, IDispatchProps, IProps>(mapStateToProps, mapDispatchToProps)(ManifestLoader);
